var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-medal"},_vm._l((_vm.medals),function(item){return _c('a',{key:item.id,staticClass:"u-medal",attrs:{"href":_vm.medalLink(item),"target":"_blank","title":item.medal_desc}},[_c('img',{staticClass:"u-medal-img",attrs:{"src":_vm.showIcon(item.medal)}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }